export default "__VITE_ASSET__3ca3b620__"